import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  fill: "none",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g stroke=\"#000\" stroke-width=\"1.5\" clip-path=\"url(#cart_svg__a)\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M15.227 17.282H6.584c-.637 0-1.182-.46-1.288-1.09L3 2.692a1.31 1.31 0 0 0-1.288-1.086H.853\"></path><path d=\"M13.593 19.895a.327.327 0 1 0 0-.653m-.001.653a.327.327 0 1 1 0-.653m-6.532.653a.327.327 0 1 0 0-.653m-.001.653a.327.327 0 0 1 0-.653\"></path><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.814 13.362h10.515a2.614 2.614 0 0 0 2.535-1.98l1.263-5.052a.653.653 0 0 0-.634-.811H3.48\"></path></g><defs><clipPath id=\"cart_svg__a\"><path fill=\"#fff\" d=\"M0 .75h20v20H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }